// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checklist-report-selection-dialog .mat-mdc-dialog-container {
  overflow: visible;
}
.checklist-report-selection-dialog .mat-mdc-dialog-container .mat-mdc-dialog-content {
  overflow: visible;
}

.checklist-report-selection-dialog .report-filter-row > div:not(:first-child):not(.report-filter-date-divider):not(.start-date):not(.end-date) {
  padding-left: 0;
}
.checklist-report-selection-dialog .report-filter-row > div:not(:last-child):not(.report-filter-date-divider):not(.start-date):not(.end-date) {
  padding-right: 0;
}
.checklist-report-selection-dialog .report-filter-name {
  display: none;
}
.checklist-report-selection-dialog > .content {
  padding: 20px;
}
.checklist-report-selection-dialog .report-filter-date {
  width: 50%;
}
.checklist-report-selection-dialog .report-filter-date.start-date {
  padding-right: 10px;
}
.checklist-report-selection-dialog .report-filter-date.end-date {
  padding-left: 10px;
}
.checklist-report-selection-dialog .report-filter-date-divider {
  display: none;
}
.checklist-report-selection-dialog .report-filter-actions {
  display: none;
}
.checklist-report-selection-dialog .report-filter-units,
.checklist-report-selection-dialog .report-filter-business-areas {
  width: 100%;
  float: none;
  clear: both;
  margin-top: 15px;
}`, "",{"version":3,"sources":["webpack://./Source/app/checklist-report/view/checklist-report-selection-dialog/checklist-report-selection-dialog.component.scss"],"names":[],"mappings":"AACI;EACI,iBAAA;AAAR;AACQ;EACI,iBAAA;AACZ;;AAMQ;EACI,eAAA;AAHZ;AAKQ;EACI,gBAAA;AAHZ;AAOI;EACI,aAAA;AALR;AAQI;EACI,aAAA;AANR;AASI;EACI,UAAA;AAPR;AASQ;EACI,mBAAA;AAPZ;AAUQ;EACI,kBAAA;AARZ;AAYI;EACI,aAAA;AAVR;AAaI;EACI,aAAA;AAXR;AAcI;;EAEI,WAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;AAZR","sourcesContent":[".checklist-report-selection-dialog {\r\n    .mat-mdc-dialog-container {\r\n        overflow: visible;\r\n        .mat-mdc-dialog-content {\r\n            overflow: visible;\r\n        }\r\n    }\r\n}\r\n\r\n.checklist-report-selection-dialog {\r\n    .report-filter-row > div {\r\n        &:not(:first-child):not(.report-filter-date-divider):not(.start-date):not(.end-date) {\r\n            padding-left: 0;\r\n        }\r\n        &:not(:last-child):not(.report-filter-date-divider):not(.start-date):not(.end-date) {\r\n            padding-right: 0;\r\n        }\r\n    }\r\n\r\n    .report-filter-name {\r\n        display: none;\r\n    }\r\n\r\n    > .content {\r\n        padding: 20px;\r\n    }\r\n\r\n    .report-filter-date {\r\n        width: 50%;\r\n\r\n        &.start-date {\r\n            padding-right: 10px;\r\n        }\r\n\r\n        &.end-date {\r\n            padding-left: 10px;\r\n        }\r\n    }\r\n\r\n    .report-filter-date-divider {\r\n        display: none;\r\n    }\r\n\r\n    .report-filter-actions {\r\n        display: none;\r\n    }\r\n\r\n    .report-filter-units,\r\n    .report-filter-business-areas {\r\n        width: 100%;\r\n        float: none;\r\n        clear: both;\r\n        margin-top: 15px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
